const DataDeviceEvents = {
  TRIGGER_FETCH_OF_DATA_DEVICES_TO_DISPLAY: 'triggerFetchOfDataDevicesToDisplay',
  DATA_DEVICES_DESELECT_ALL: 'dataDeviceSelectionDeselectAll',
  UPDATE_DATA_DEVICE_SELECTION_DEVICES: 'updateDataDeviceSelectionDevices',
  FETCH_DATA_DEVICES_TO_DISPLAY: 'fetchDataDevicesToDisplay',
  MOUNT_DATA_DEVICES_SELECTION: 'mountDataDeviceSelection',
};

export default DataDeviceEvents;
